import type { Cols, SizeStep, WidgetLayoutItem } from '../../platform/grid/gridMaths'
import type { Breakpoint } from '../../platform/responsive/useBreakpoint'

export type PanelId = 'over' | 'bars' | 'radar' | 'list'

/** The spec's sizes (M4-budget.md:22-31), except the list: 4×5, not 4×4, because at 406px it sliced a row of the primary content. */
export const SIZES: Record<PanelId, { w: Cols; h: SizeStep }> = {
  over: { w: 1, h: 2 },
  bars: { w: 3, h: 3 },
  radar: { w: 2, h: 3 },
  list: { w: 4, h: 5 },
}

/**
 * The radar goes last: `over, bars, radar, list` leaves a 2-column × 4-row hole beside
 * the radar at four columns (3×3 and 2×3 cannot share a four-column row). Last, the
 * hole trails. The tile and the bars still lead the list.
 */
export const DESKTOP_ORDER: readonly PanelId[] = ['over', 'bars', 'list', 'radar']

/** M4-R19 / R21: on a phone the list leads and there is no radar. */
export const PHONE_ORDER: readonly PanelId[] = ['list', 'over', 'bars']

export function layoutFor(bp: Breakpoint): WidgetLayoutItem<PanelId>[] {
  return (bp === 'phone' ? PHONE_ORDER : DESKTOP_ORDER).map((id) => ({ id, ...SIZES[id] }))
}
